import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from 'admin/components/shared/Button';

const DeviceTypeSelectTab = styled.div`
  padding: 15px 0;
  button {
    box-shadow: none;
    outline: none !important;
    border-radius: 0 0 0 0 !important;
    margin-left: 2px;
  }
  .active {
    box-shadow: inset 0px 0px 10px 0px rgba(0, 0, 0, 0.2) !important;
  }
  button:first-child {
    border-radius: 6px 0 0 6px !important;
    margin-left: 0px;
  }
  button:last-child {
    border-radius: 0 6px 6px 0 !important;
  }
`;

class DeviceTypeSelect extends Component {
  onClickedPayregi = () => {
    this.props.onSelectPayregi();
  };

  onClickedOldPayregi = () => {
    this.props.onSelectOldPayregi();
  };

  onClickedPaybox = () => {
    this.props.onSelectPaybox();
  };

  onClickedPayspot = () => {
    this.props.onSelectPayspot();
  };

  onClickedKiosk = () => {
    this.props.onSelectKiosk();
  };

  render() {
    const tab = this.props.activeDeviceTab;
    return (
      <DeviceTypeSelectTab>
        <Button onClick={this.onClickedPayspot} color={tab === 'payspot' ? 'normal' : 'gray'}>
          ペイスポット
        </Button>
          <Button onClick={this.onClickedPayregi} color={tab === 'payregi' ? 'normal' : 'gray'}>
              新ペイレジ
          </Button>
          <Button
              onClick={this.onClickedOldPayregi}
              color={tab === 'oldpayregi' ? 'normal' : 'gray'}
          >
              旧ペイレジ
        </Button>
        <Button onClick={this.onClickedPaybox} color={tab === 'paybox' ? 'normal' : 'gray'}>
          ペイボックス
        </Button>
        <Button onClick={this.onClickedKiosk} color={tab === 'kiosk' ? 'normal' : 'gray'}>
          チャージ機
        </Button>
      </DeviceTypeSelectTab>
    );
  }
}

DeviceTypeSelect.propTypes = {
  activeDeviceTab: PropTypes.string.isRequired,
  onSelectPayregi: PropTypes.func.isRequired,
  onSelectOldPayregi: PropTypes.func.isRequired,
  onSelectPaybox: PropTypes.func.isRequired,
  onSelectPayspot: PropTypes.func.isRequired,
  onSelectKiosk: PropTypes.func.isRequired,
};

export default DeviceTypeSelect;
